import { Spin } from 'antd'
import { FC, Suspense } from 'react'
import { I18nextProvider } from 'react-i18next'
import { Provider } from 'react-redux'
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom'
import { PersistGate } from 'redux-persist/es/integration/react'
import { LanguageProvider } from './contexts/LanguageContext'
import { PWAProvider } from './contexts/PWAContext'
import OfflinePage from './pages/OfflinePage'
import rootReducer from './redux'
import configureStore from './redux/configureStore'
import Routes from './routes/Routes'
import history from './utils/history'
import i18n from './utils/i18n'

const { store, persistor } = configureStore(rootReducer)

const App: FC = () => {
	return (
		<Suspense fallback={<Spin size={'large'} />}>
			<I18nextProvider i18n={i18n}>
				<PersistGate loading={<Spin size={'large'} />} persistor={persistor}>
					<Provider store={store}>
						<HistoryRouter history={history as any}>
							<LanguageProvider>
								<PWAProvider>
									<OfflinePage>
										<Routes />
									</OfflinePage>
								</PWAProvider>
							</LanguageProvider>
						</HistoryRouter>
					</Provider>
				</PersistGate>
			</I18nextProvider>
		</Suspense>
	)
}

export default App
